module.exports = __webpack_public_path__ + "mainassets/img/tile-info-illustartion.a1609f25.svg";